<script>
import ReportingApi from "@/services/reporting-api";

export default {
    data(){
        return{
            synchronizationHistory: [],
            fields: [ 
                { key:"timestamp", label: ""},
                { key:"method", label: ""},
                { key:"url", label: ""},
                { key:"result", label: ""},
                { key:"errorCode", label: ""},
                { key:"action", label: ""},

                ],
            pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
            end:null,
            start:null,
            isTableBusy:false,
            selectedData:null,
            showModal:false,
        }
    },
    methods:{
        getSyncHistory(){
            this.isTableBusy=true
            ReportingApi.getSyncHistory(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end).then(
                (result) => {
                    if(result){
                        this.synchronizationHistory=result.list;
                        this.pagemodel.totalRows = result.total;
                        this.pagemodel.currentPage = result.page;
                        this.pagemodel.perPage = result.pageSize;
                        this.pagemodel.pageSize = result.pageSize;
                    }
                }
            ).finally(()=>{
                this.isTableBusy=false
            })
        },

    },
    mounted(){
      this.getSyncHistory()
    },

    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getSyncHistory()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getSyncHistory()
          }
        },
    }

}
</script>
<template>
    <div class="clearfix m-4">
        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-primary"> {{$t("reporting.supplier.tabSynchro.cardTitle")}} </h4>
        <div  class="row mt-4">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"   label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
        </div>
        <div class="table-responsive mb-0" >
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="synchronizationHistory"
            :fields="fields"
            :perPage="pagemodel.perPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            </template>
            <template v-slot:head(method)>
                {{ $t("reporting.supplier.tabSynchro.fields.method") }} 
            </template>
            <template v-slot:head(url)>
                {{ $t("reporting.supplier.tabSynchro.fields.url") }} 
            </template>
            <template v-slot:head(result)>
                {{ $t("reporting.supplier.tabSynchro.fields.result") }} 
            </template>
            <template v-slot:head(errorCode)>
                {{ $t("reporting.supplier.tabSynchro.fields.errorCode") }} 
            </template>
            <template v-slot:head(timestamp)>
                {{ $t("reporting.supplier.tabSynchro.fields.timestamp") }} 
            </template>
            <template v-slot:cell(result)="{value}">
                <code>{{value}}</code>
            </template>
            <template v-slot:cell(action)="{item}">
                <!-- <i class="fas fa-info-circle text-info font-weight-bold font-size-16" style="cursor:pointer" :title="$t('subscription.showDetails')" @click="selectedData=item;showModal=true" ></i> -->
                <b-button title="Details"  size="sm"   variant="outline-danger"  @click.prevent="selectedData=item;showModal=true"   >
                    <i class="fas fa-info-circle  font-size-16  font-weight-bold align-middle mr-0 mr-sm-2"></i>
                    <span class=" font-weight-bold text-uppercase d-none d-sm-inline">Details </span>         
                </b-button>
            </template>
            </b-table>
        </div>
        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getSyncHistory()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getSyncHistory()" :disabled="isTableBusy" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->  
            
        <b-modal v-if="selectedData"
            v-model="showModal"
                :title="$t('reporting.supplier.tabSynchro.modal.title')"
                centered 
                title-class="text-primary"
                title-tag="h5"
                header-close-variant="danger"
                hide-footer
                hide-header
                size="xl">

                <div class="form-group row mb-2">
                    <label class="col-12 col-form-label font-size-14">{{$t('reporting.supplier.tabSynchro.modal.request')}}</label>
                    <div class="col-12">
                        <textarea
                            v-model="this.selectedData.request"
                            class="form-control text-dark font-weight-bold"
                            rows="5"
                            disabled
                        >
                        </textarea>
                    </div>
                </div>

                <div class="form-group row mb-0">
                    <label class="col-12 col-form-label font-size-14">{{$t('reporting.supplier.tabSynchro.modal.response')}}</label>
                    <div class="col-12">
                        <textarea
                            v-model="this.selectedData.response"
                            class="form-control text-danger font-weight-bold"
                            rows="5"
                            disabled
                        >
                        </textarea>
                    </div>
                </div>
        </b-modal>
    </div>
</template>